import type * as React from 'react'

/** Google Maps search for a site address (#548). Opens in a new tab. */
export function mapsUrl(address: string): string {
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`
}

/** A site address as a map link. `href` overrides the Google search URL (the account page uses the API's). */
export function AddressLink({
  address,
  href,
  className,
  children,
}: {
  address: string
  href?: string
  className?: string
  children?: React.ReactNode
}) {
  return (
    <a
      href={href || mapsUrl(address)}
      target="_blank"
      rel="noopener noreferrer"
      className={className ?? 'underline-offset-2 hover:underline'}
      onClick={(event) => event.stopPropagation()}
    >
      {children ?? address}
    </a>
  )
}
